import {FormValidationService, NavigationService} from '@utils-lib';
import {
    Component,
    ElementRef,
    Inject,
    Injector,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterEvent} from '@angular/router';
import {FrontendDocument, FrontendStatusEnum} from '@nachdigal';
import {TranslateService} from '@ngx-translate/core';
import {DatevNotificationService} from '@datev/ngx-ui-components';
import {Subscription} from 'rxjs';
import {LoaderService} from '../shared/service/loader.service';
import {NavigationProviderService} from '@common-ui-lib';
import {BannerService} from '../shared/service/banner.service';

@Component({
    selector: 'common-ui-fragebogen',
    templateUrl: './fragebogen.component.html',
    styleUrls: ['./fragebogen.component.scss']
})
export class FragebogenComponent implements OnInit, OnDestroy {

    @ViewChild('appHeader') appHeaderElement;

    public currentItemIndex: number;
    public readonly: boolean;
    public disableNavigation: boolean;
    public statusSubscription: Subscription;
    public validatorSubscription: Subscription;
    public routerEventSubscription: Subscription;

    public readonly navigationProvider: NavigationProviderService;
    private readonly router: Router;
    private readonly formValidationService: FormValidationService;
    private readonly activatedRoute: ActivatedRoute;
    private readonly datevNotificationService: DatevNotificationService;
    private readonly elementRef: ElementRef;
    private readonly translateService: TranslateService;
    private readonly navigationService: NavigationService;
    private readonly loaderService: LoaderService;
    private readonly bannerService: BannerService;

    constructor(
        @Inject('Window') private readonly window: Window,
        private readonly injector: Injector) {

        this.router = injector.get<Router>(Router);
        this.formValidationService = injector.get<FormValidationService>(FormValidationService);
        this.activatedRoute = injector.get<ActivatedRoute>(ActivatedRoute);
        this.datevNotificationService = injector.get<DatevNotificationService>(DatevNotificationService);
        this.elementRef = injector.get<ElementRef>(ElementRef);
        this.translateService = injector.get<TranslateService>(TranslateService);
        this.navigationProvider = injector.get<NavigationProviderService>(NavigationProviderService);
        this.navigationService = injector.get<NavigationService>(NavigationService);
        this.loaderService = injector.get<LoaderService>(LoaderService);
        this.bannerService = injector.get<BannerService>(BannerService);

        this.loaderService.isLoading = {isLoading: false};

        this.routerEventSubscription = this.router.events.subscribe((event: RouterEvent) => {
            if (!(event instanceof NavigationEnd)) {
                return;
            }
            const element = this.elementRef.nativeElement.querySelector('.form-control,.form-check-label,.btn');
            element?.focus();
            this.currentItemIndex = this.navigationProvider.navigationPages.findIndex(item => event.urlAfterRedirects.includes(item.route));
            // TODO ERIC RESPONSE PROPOSAL. PLEASE DO NOT DELETE THE FOLLOWING LINES
            // const state = this.router.getCurrentNavigation().extras.state;
            // if (!!state) {
            //     const elements = this.elementRef.nativeElement.querySelectorAll(`[data-eric-id]`);
            //     for (let e of elements) {
            //         // console.log(e.dataset.ericId);
            //     }
            //     // if (!!element) {
            //     //     setTimeout(() => {
            //     //         element.scrollIntoView({block: 'end', behavior: 'smooth'});
            //     //         element.focus();
            //     //     });
            //     // }
            // }
        });

        this.statusSubscription = this.navigationService.getDisableStatus().subscribe(disableNavigation => {
            this.disableNavigation = disableNavigation;
        });

        this.validatorSubscription = this.formValidationService.validateForm.subscribe(() => this.doValidate());

    }

    private static isReadonly(status: FrontendDocument): boolean {
        return status === FrontendStatusEnum.SendingConfirmed ||
            status === FrontendStatusEnum.SendingFinalized ||
            status === FrontendStatusEnum.Sending ||
            status === FrontendStatusEnum.SendingSuccessful;
    }

    public ngOnInit(): void {
        const frontendDocument = this.activatedRoute.snapshot.data.document;
        this.navigationService.onMandantNameUpdated(frontendDocument.client_name, null);
        this.readonly = FragebogenComponent.isReadonly(frontendDocument.status);
        /* const isDraft = frontendDocument.status === FrontendStatusEnum.Created;
        const taskVersion = this.activatedRoute.snapshot.data.taskData.metadaten.task_data_version;
        if (isDraft && taskVersion !== '2024') {
            this.bannerService.setGeneralBannerVisibility(true);
        } */
    }

    public ngOnDestroy(): void {
        this.validatorSubscription.unsubscribe();
        this.statusSubscription.unsubscribe();
        this.routerEventSubscription.unsubscribe();
        const messageBanner = document.getElementById('message-banner');
        if (messageBanner) {
            messageBanner.className = messageBanner.className.replace('hide-banner', '');
        }
    }

    public onValidateButtonClick(): void {
        this.formValidationService.validateForm.emit();
    }

    private doValidate(): void {
        setTimeout(() => {
            const mainForm = this.elementRef.nativeElement.querySelector('form.ng-invalid');
            if (mainForm) {
                // for cases where there are forms in lists
                const containingForm = mainForm.closest('div.containing-form');
                containingForm?.classList.add('display-list-item-form');
                const formLiSibling = containingForm?.previousSibling;
                formLiSibling?.classList.add('list-group-item-selected');
                formLiSibling?.firstChild?.classList.add('active');

                const element = mainForm.querySelector('.ng-invalid:not(form), div.common-ui-card-danger');
                try {
                    element.scrollIntoView({block: 'end', behavior: 'smooth'});
                    element.focus();
                } catch (e) {
                }
            } else {
                const message = this.translateService.instant('COMMON_UI.NAVIGATION.VALIDATE_SUCCESS_MESSAGE');
                this.datevNotificationService.showToast(message);
            }
        });
    }

}
